module.exports = __webpack_public_path__ + "img/ranktop_icon02.80f63fd7.png";